import { formatChatMessageHtml } from "@/lib/formatChatMessageHtml";

/**
 * Renders chat message text with safe markdown (lists, bold, links, paragraphs).
 * @param {{ text?: string | null, className?: string }} props
 */
export default function ChatMessageBody({ text, className = "" }) {
  const raw = text != null ? String(text) : "";
  if (!raw.trim()) return null;
  return (
    <div
      className={`chat-message-body min-w-0 max-w-full break-words [overflow-wrap:anywhere] ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: formatChatMessageHtml(raw) }}
    />
  );
}
